export default function under13Pose({ avatarUrl }: { avatarUrl: string }): string {
  const randomPose = Math.ceil(Math.random() * 5)
  const lookingFor = 'under-13/glb/'
  const replaced = avatarUrl
    ? avatarUrl
        .slice(avatarUrl.indexOf(lookingFor) + lookingFor.length)
        .replace('-', '_')
        .replace('.glb', '.png')
    : undefined

  const avatarPose = `avatars/custom/under-13/png/pose/pose_0${randomPose}_${replaced}`

  return avatarPose
}
